import {
    Component, OnInit, Input, ChangeDetectionStrategy,
    ViewChild, SimpleChanges, OnChanges
} from '@angular/core';
// Animations

import { Router } from '@angular/router';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import { saveAs } from 'file-saver';
import { slideInDownAnimation } from 'src/app/app.animation';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LGEDataService } from 'src/commons';

@Component({
    selector: 'ccms-table-component',
    templateUrl: './ccms-table.component.html',
    styleUrls: ['./ccms-table.component.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CCMSTableComponent implements OnInit, OnChanges {
    @ViewChild(MatPaginator)
    paginator!: MatPaginator;
    @ViewChild(MatSort)
    sort!: MatSort;
    @Input('isLoading') isLoading: boolean = false;
    @Input('data') data: any[] = [];
    @Input('displayedColumns') displayedColumns: any[] = ['requestNo', 'formCCName', 'OrgInfo.name', 'OrgInfo.subsection', 'effdt', 'statusDescr', 'FormCCLogInfo.empName', 'FormCCLogInfo.title', 'FormCCLogInfo.comment', 'print-view'];
    // public displayedColumns = ['requestNo', 'formCCName', 'OrgInfo.name', 'effdt', 'statusDescr', 'FormCCLogInfo.empName', 'FormCCLogInfo.title', 'FormCCLogInfo.comment', 'print'];
    dataSource: any;
    datePipe = new DatePipe('en-US');
    isPrinting = false;

    constructor(
        private router: Router,
        private lgeDataService: LGEDataService,
    ) {
        // if (this.displayedColumns === undefined) {
        //     this.displayedColumns 

        // }
    }

    public ngOnInit() {
        setTimeout(() => {
            this.dataSource = new MatTableDataSource(this.data);
            // Sorting nested object
            this.dataSource.sortingDataAccessor = (item: { [x: string]: any; requestNo: string; OrgInfo: { name: string; }; FormCCLogInfo: { empName: string; title: string; comment: string; }; effdt: string | number | Date; }, property: string | number) => {
                switch (property) {
                    case 'requestNo': return item.requestNo.substring(2);
                    case 'OrgInfo.name': return item.OrgInfo.name.toLowerCase();
                    case 'FormCCLogInfo.empName': return item.FormCCLogInfo.empName.toLowerCase();
                    case 'FormCCLogInfo.title': return item.FormCCLogInfo.title.toLowerCase();
                    case 'FormCCLogInfo.comment': return item.FormCCLogInfo.comment.toLowerCase();
                    case 'effdt': return new Date(item.effdt);
                    default: return item[property];
                }
            };
            this.dataSource.filterPredicate = (data: { [x: string]: any; OrgInfo?: any; FormCCLogInfo?: any; effdt?: any; }, filter: string) => {
                const accumulator = (currentTerm: string, key: string | number) => {
                    switch (key) {
                        case 'OrgInfo':
                            return currentTerm + data.OrgInfo.name;
                        case 'FormCCLogInfo':
                            return currentTerm + data.FormCCLogInfo.empName
                                + data.FormCCLogInfo.title
                                + data.FormCCLogInfo.comment;
                        case 'effdt':
                            const newDate = this.datePipe.transform(data.effdt, 'MM-dd-yyyy')?.toString();
                            return currentTerm + newDate;
                        default:
                            return currentTerm + data[key];
                    }
                    // return key === 'OrgInfo' ? currentTerm + data.OrgInfo.name : currentTerm + data[key];
                };
                const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
                // Transform the filter by converting it to lowercase and removing whitespace.
                const transformedFilter = filter.trim().toLowerCase();
                return dataStr.includes(transformedFilter);
            };
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        });
    }

    public ngOnChanges(changes: SimpleChanges) {
        // console.log(changes);
        if (changes['data'] && changes['isLoading']) {
            setTimeout(() => {
                this.dataSource = new MatTableDataSource(changes['data'].currentValue);

                this.dataSource.sortingDataAccessor = (item: { [x: string]: any; requestNo: string; OrgInfo: { name: string; }; FormCCLogInfo: { empName: string; title: string; comment: string; }; effdt: string | number | Date; }, property: string | number) => {
                    switch (property) {
                        case 'requestNo': return item.requestNo.substring(2);
                        case 'OrgInfo.name': return item.OrgInfo.name.toLowerCase();
                        case 'FormCCLogInfo.empName': return item.FormCCLogInfo.empName.toLowerCase();
                        case 'FormCCLogInfo.title': return item.FormCCLogInfo.title.toLowerCase();
                        case 'FormCCLogInfo.comment': return item.FormCCLogInfo.comment.toLowerCase();
                        case 'effdt': return new Date(item.effdt);
                        default: return item[property];
                    }
                };
                // const datePipe = new DatePipe('en-US');
                this.dataSource.filterPredicate = (data: { [x: string]: any; OrgInfo?: any; FormCCLogInfo?: any; effdt?: any; }, filter: string) => {
                    const accumulator = (currentTerm: string, key: string | number) => {
                        switch (key) {
                            case 'OrgInfo':
                                return currentTerm + data.OrgInfo.name;
                            case 'FormCCLogInfo':
                                return currentTerm + data.FormCCLogInfo.empName
                                    + data.FormCCLogInfo.title
                                    + data.FormCCLogInfo.comment;
                            case 'effdt':
                                const newDate = this.datePipe.transform(data.effdt, 'MM-dd-yyyy')?.toString();
                                return currentTerm + newDate;
                            default:
                                return currentTerm + data[key];
                        }
                        // return key === 'OrgInfo' ? currentTerm + data.OrgInfo.name : currentTerm + data[key];
                    };
                    const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
                    // Transform the filter by converting it to lowercase and removing whitespace.
                    const transformedFilter = filter.trim().toLowerCase();
                    return dataStr.includes(transformedFilter);
                };

                this.isLoading = changes['isLoading'].currentValue;
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            });
        }
    }

    public getStatusClass(status: string): string {
        const possibleStatus = ['Submitted', 'Pending', 'Draft', 'Approved', 'Pending Approval', 'Rejected', 'Pending  VP, CR & CA Approval',
            'Sent To Foundation Trustee', 'Sent To Oracle', 'Waiting For Oracle', 'Withdrawn', 'Paid Credit', 'Check Cashed', 'Check Issued', 'Check Voided', 'Check Cleared', 'Cancelled'];
        // return possibleStatus.indexOf(status) > -1 ? status.toLowerCase() : '';
        return status.toLowerCase();
    }

    getTaxExemptStatus(value) {
        if (value === '')
            return 'Other';
        else if (isNaN(value) || +value === 0) {
            return value;
        } else {
            return `501(c)(${+value})`;
        }
    }

    public selectRow(row: { requestNo: string; FormCCOeBS: any; formccId: any; }): void {
        if (this.isPrinting) {
            this.isPrinting = false;
            this.lgeDataService.DownloadFormAsPDF(row.requestNo).subscribe((response: any) => {
                saveAs(response, `${row.requestNo}.pdf`);
            });
            // window.open(url, '_blank');
        } else {
            if (row.requestNo.substring(0, 2) == 'CC') {
                this.lgeDataService.setIsAdminReject(row.FormCCOeBS);
                // this.formCCService.setpendingApprovalFormCCData(row);
                this.router.navigate([`charity-forms/charitable-contribution/${row.formccId}`]);
            } else {
                this.router.navigate([`charity-forms/matching-gift/${row.formccId}`])
            }
        }
    }

    onPrint() {
        this.isPrinting = true;
    }

    public applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }
}
